import styled from 'styled-components'
import tag from 'clean-tag'
import Link from 'gatsby-link'
import {injectGlobal} from 'styled-components';
import {grid} from 'styled-components-grid'
import {p, my} from 'styled-components-spacing'
import {
  textAlign,
  position,
  width,
  left,
  right,
  bottom,
  top,
  space
} from 'styled-system'
import { createMuiTheme } from '@material-ui/core/styles';

injectGlobal`
  body {
    font-size: 62.5%;
  } 
`

export const opacity = `
  background: rgba(255,255,255,.8);
`;

export const GridContainer = styled.div`
  margin: 0 auto;
  max-width: 62rem;
  width: 100%;
`;

export const FullImage = styled.img`
  width: 100%;
  margin-bottom: 0;
  display: block;
`;

export const Image = styled(tag.img)`
  ${width}
  ${space}
`

export const SpacedGridUnit = styled.div`
  ${p(2)};
  ${my({mobile:0, tablet:2})};
  text-align: center;
`;

export const Box = styled.div`
  ${textAlign}
  ${position}
  ${width}
  ${left}
  ${right}
  ${bottom}
  ${top}
  ${space}
`;

export const IntroGridUnit = styled(SpacedGridUnit)`
  ${grid.unit({size:6/10})};
`;
export const BlockedLink = styled(Link)`
  display: block
`
export const OpacSpacedGridUnit = SpacedGridUnit.extend`
  ${opacity}
  position: relative;
`;

export const LinkPlus = styled(Link)`
  border-radius: 100%;
  border: 1px solid black;
  background: white;
  color: black;
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
  font-size: 2rem;
  line-height: 1.3rem;
  text-decoration: none;
  &:hover {
    background: black;
    color: white;
  }
`
export const MuiTheme = createMuiTheme({})



// WEBPACK FOOTER //
// ./src/components/Styles.js